import React from "react";

const ContactUs = () => {
  return (
    <section style={styles.section}>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
          
          .contact-card {
            background: linear-gradient(145deg, #111 0%, #000 100%);
            border: 1px solid rgba(212, 175, 55, 0.3);
            border-radius: 20px;
            padding: 50px 35px;
            box-shadow: 0 0 20px rgba(212, 175, 55, 0.1);
            text-align: right;
            direction: rtl;
            transition: all 0.3s ease;
          }

          .contact-card:hover {
            box-shadow: 0 0 25px rgba(212, 175, 55, 0.25);
            transform: translateY(-5px);
          }

          .office-name {
            font-size: 24px;
            font-weight: 700;
            color: #d4af37;
            margin-bottom: 25px;
            border-bottom: 1px solid rgba(212, 175, 55, 0.3);
            padding-bottom: 10px;
          }

          .contact-info p {
            display: flex;
            align-items: center;
            color: #e8e8e8;
            margin: 12px 0;
            line-height: 1.7;
            font-size: 17px;
          }

          .icon {
            color: #d4af37;
            margin-left: 12px;
            font-size: 20px;
          }

          .send-btn {
            display: inline-block;
            background-color: #d4af37;
            color: #000;
            padding: 14px 40px;
            border-radius: 40px;
            font-weight: bold;
            text-decoration: none;
            font-size: 16px;
            letter-spacing: 0.5px;
            transition: 0.3s;
          }

          .send-btn:hover {
            background-color: #b8962d;
            transform: translateY(-3px);
          }

          .whatsapp-btn {
            display: inline-block;
            background-color: #25D366;
            color: #fff;
            padding: 14px 40px;
            border-radius: 40px;
            font-weight: bold;
            text-decoration: none;
            font-size: 16px;
            margin-right: 10px;
            transition: 0.3s;
          }

          .whatsapp-btn:hover {
            background-color: #1ea958;
            transform: translateY(-3px);
          }
        `}
      </style>

      <div style={styles.container}>
        <h2 style={styles.title}>تواصل معنا ⚖️</h2>

        <div className="contact-card">
          <h3 className="office-name">مكتب علاء الدين حامد – المحامي بالنقض</h3>

          <div className="contact-info">
            <p>
              <span className="icon">📍</span>
              30 ش عباس العقاد
            </p>
            <p>
              <span className="icon">✉️</span>
              info@alaa-hamed.com
            </p>
            <p>
              <span className="icon">📞</span>
              01110251645 – 01027050624
            </p>
            <p>
              <span className="icon">🕒</span>
              المكتب بيستقبل العملاء من السبت إلى الأربعاء، من الساعة 7 مساءً
              حتى 11 مساءً، ويمكن حجز موعد مسبق لتأكيد الحضور.
            </p>
          </div>

          <div className="buttons">
            <a href="mailto:info@alaa-hamed.com" className="send-btn">
              ✉️ أرسل رسالة الآن
            </a>
            <a
              href="https://wa.me/201110251645"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
            >
              💬 تواصل عبر واتساب
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#000",
    color: "#d4af37",
    padding: "80px 20px",
    textAlign: "center",
    fontFamily: "'Cairo', sans-serif",
    direction: "rtl",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "40px",
    color: "#d4af37",
    borderBottom: "2px solid rgba(212, 175, 55, 0.3)",
    display: "inline-block",
    paddingBottom: "10px",
  },
};

export default ContactUs;
